import React, {PureComponent} from 'react';
import concat from 'lodash/concat';
import chunk from 'lodash/chunk';
import ShopItem from './shop_item';
import EmptyShopResult from './EmptyShopResult';

export default class ShopItems extends PureComponent {
    render() {
        const {lootboxes = [], user, currency, noChunks, hiddenEmpty, game, afterBuy, scrollToTopBlock, isCasinoPage} = this.props;

        if (lootboxes.length === 0) {
            return hiddenEmpty ? null : <EmptyShopResult currency={this.props.currency}/>;
        }

        if (noChunks) {
            return <div className="market__lootboxes--row">
                {lootboxes.map((lootbox, index) => <ShopItem
                    key={`lootbox-${lootbox.id}-${index}`}
                    currency={currency}
                    {...lootbox}
                    game={lootbox.game || game}
                    afterBuy={afterBuy}
                    user={user}
                    isCasinoPage={isCasinoPage}
                    scrollToTopBlock={scrollToTopBlock}
                />)}
            </div>;
        }

        return concat(chunk(lootboxes, 4).map((chunk, i) => <div
            key={i}
            className="market__lootboxes--row"
        >
            {chunk.map((lootbox, index) => <ShopItem
                key={`lootbox-${lootbox.id}-${index}`}
                currency={currency}
                {...lootbox}
                game={lootbox.game || game}
                user={user}
            />)}
        </div>));
    }
}
